import { LocationDataRegion, NameIdItem } from '@alluradirect/react';

export const getSelectedRegion = (selectedRegion: string, regions: LocationDataRegion[]) => {
  let newRegion = { NAME: '', ID: 0, COUNTRY_ID: 0 };
  const selectedRegions = regions.filter(region => region.NAME === selectedRegion);

  if (selectedRegions.length > 0) newRegion = selectedRegions[0];

  return newRegion;
};

export const getSelectedCountry = (selectedCountry: string, countries: NameIdItem[]) => {
  let newCountry = { NAME: '', ID: 0 };
  const selectedCountries = countries.filter(country => country.NAME === selectedCountry);

  if (selectedCountries.length > 0) newCountry = selectedCountries[0];

  return newCountry;
};
